import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.error - string not empty (otherwise this component output no visible content)
*/

const UniFormcompoErrorInField = (props) => {
  let jsx = null;
  if (typeof props.error === 'string' && props.error !== '') {
    jsx = <div className="uniformcompo__error-in-field"><span>*</span> {props.error}</div>
  }
  return (
    <>
     {jsx}
    </>
  );
};

export default UniFormcompoErrorInField;